export default __webpack_public_path__ + "static/media/green-tick.02317044.svg";